// extracted by mini-css-extract-plugin
module.exports = {"button":"provider-manage-modal_button_269Qs","uploaderContainer":"provider-manage-modal_uploaderContainer_3uftU","uploader":"provider-manage-modal_uploader_2UuOv"};